<template>
    <div>
        <config-main-title v-if="!financeiro">
            Contas
        </config-main-title>

        <div class="row mb-3">
            <div class="col col-12 col-md-6">
                <az-input icon="fas fa-search" v-model="search" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'A'">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'T'">
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="incluirConta ()">
                    Incluir
                </button>
            </div>
        </div>

        <div v-if="dados && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item hover-bg" v-for="(dado, id) in lista" :key="id">
                    <div class="d-flex justify-content-between">
                        <span class="h5 card-link mb-0 mr-3">
                            <a href="#" @click.prevent="editar (dado)">
                                {{ dado.search }}
                            </a>
                            <template v-if="dado.unidade_operacao">
                                <span class="badge badge-light ml-3">
                                    {{ dado.unidade_operacao.st_sigla ? dado.unidade_operacao.st_sigla : dado.unidade_operacao.search }}
                                </span>
                            </template>
                            <span v-if="!dado.fl_fluxo" class="ml-3" title="Não exibir no fluxo de caixa realizado.">
                                <i class="fas fa-eye-slash"></i>
                            </span>
                        </span>
                        <span>
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" 
                                    :id="'categoria-' + id " 
                                    v-model="dado.fl_ativo"
                                    @change="toggle(dado)">
                                <label class="custom-control-label" :for="'categoria-' + id "></label>
                            </div>
                            <div v-else class="d-flex">
                                <div v-if="dado.js_classes">
                                    <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                        v-for="(tag, itx) in dado.js_classes" :key="itx">
                                        <span class="badge badge-success ml-1">
                                            {{ tag }}
                                        </span>
                                    </a>
                                </div>
                                <div v-if="dado.acessos && dado.acessos.length">
                                    <span class="badge badge-secondary ml-2">
                                        {{ dado.acessos.length }}
                                    </span>
                                </div>
                                <button type="button" class="btn ml-2 btn-outline-secondary" @click="acessos(dado)">
                                    <i class="fas fa-user-lock"></i>
                                </button>
                            </div> 
                        </span>
                    </div>
                </li>
            </div>

            <pre v-if="1 == 0">{{ dados }}</pre>
        </div>

        <div v-else>
            <az-empty-state msg="Nenhum conta registrada." />
        </div>

        <!-- Modal -->
        <div class="modal fade" id="contaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Conta</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Nome da Conta"
                                    required 
                                    :validate="validate"
                                    v-model="item.st_conta" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Unidade"
                                    type="select"
                                    placeholder="Todas"
                                    :optionsList="$store.state.unidade.unidade_operacaos"
                                    optionsData="id_unidade_operacao"
                                    required
                                    :validate="validate"
                                    v-model="item.id_unidade_operacao" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Tipo"
                                    type="select"
                                    placeholder="Todas"
                                    :optionsList="[
                                        { id: 'X', search: 'Conta Caixa' },
                                        { id: 'C', search: 'Conta Corrente' },
                                        { id: 'A', search: 'Conta de Aplicação' },
                                        { id: 'E', search: 'Conta de Empréstimos' },
                                        { id: 'G', search: 'Conta Garantida' },
                                        { id: 'P', search: 'Conta Poupança' },
                                        { id: 'T', search: 'Conta Transitória' },
                                        { id: 'V', search: 'Conta de Vale' },
                                    ]"
                                    optionsData="id"
                                    required
                                    :validate="validate"
                                    v-model="item.st_tipo" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    type="checkbox"
                                    label="Fluxo de Caixa Realizado"
                                    v-model="item.fl_fluxo" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12 col-md-4">
                                <az-input 
                                    label="Data do Saldo Inicial"
                                    type="date"
                                    v-model="item.dt_saldo_inicial" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input 
                                    label="Saldo Inicial"
                                    type="money"
                                    v-model="item.dc_saldo_inicial" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input 
                                    label="Cheque Especial"
                                    type="money"
                                    v-model="item.dc_cheque_especial" />
                            </div>
                        </div>

                        <template v-if="item.st_tipo != 'X' && item.st_tipo != 'V'">
                            <dados-bancarios v-model="item.dados_bancarios" :validate="validate" />
                        </template>

                        <div class="row mb-1">
                            <div class="col col-12">
                                <az-input 
                                    label="Código do Convênio"
                                    required 
                                    v-model="item.st_convenio" />                            
                            </div>
                        </div>

                        <div class="row mb-1">
                            <div class="col col-12">
                                <az-input 
                                    label="Código Externo"
                                    required 
                                    v-model="item.st_id_externo" />                            
                            </div>
                        </div>

                        <div class="row mb-1">
                            <div class="col col-12">
                                <small class="text-muted">Classificação</small>
                                <multiselect
                                    v-model="item.js_classes"
                                    :options="options_classes"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTag"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação criada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button v-if="item.id_conta" model="conta" :id="item.id_conta" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_conta ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <edicao-acessos ref="acessos" @refresh="load()" />
        
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import ConfigMainTitle from '../../cadastros/shared/ConfigMainTitle.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import DadosBancarios from'../shared/DadosBancarios.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Multiselect from 'vue-multiselect';
import EdicaoAcessos from '../../cadastros/shared/EdicaoAcessos.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: 'A',
            options_classes: []
        }
    },

    props: ['financeiro'],

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados.filter (item => { 
                return ( item.fl_ativo || this.viewMode == 'T' ) && 
                    ( !this.search || reg.test(JSON.stringify(item)) )
            });
        }
    },

    components: { 
        ConfigMainTitle,
        AzEmptyState,
        AzInput,
        DadosBancarios, 
        AzSubmit, 
        AzAuditLogButton, 
        Multiselect, 
        EdicaoAcessos, 
    },

    methods: { 
        acessos(conta) { 
            this.$refs.acessos.abrir('App\\azure\\conta', conta.id_conta);
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        atualizar () { 

            this.$util.atualizar (this, { 
                service: 'contas',
                dados: this.item, 
                modal: 'contaModal',
                reload: true, 
            });

        },

        editar (item) { 
            if ( this.$store.state.loading ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "Carregando...",
                    life: 3000
                });
                return;
            }


            this.item = null;
            this.validate = false;

            this.$nextTick (() => { 
                this.item = _.cloneDeep(item);

                if ( !this.item.dados_bancarios ) { 
                    this.item.dados_bancarios = {
                        id_dados_bancarios: null, 
                        id_banco: null, 
                        in_agencia: null, 
                        in_conta: null, 
                        ch_digito_conta: null, 
                        st_observacoes: null, 
                    };
                }

                $('#contaModal').modal('show');
            });
        },

        toggle (item) { 

            this.$util.toggle (this, { 
                service: 'contas',
                dados: item, 
            });

        },

        incluirConta () { 
            this.item = null;
            this.validate = false;

            this.$nextTick (() => { 
                this.item = {
                    id_conta: null, 
                    st_conta: "", 
                    st_tipo: "C", 
                    fl_fluxo: true, 
                    dados_bancarios: {
                        id_dados_bancarios: null, 
                        id_banco: null, 
                        in_agencia: null, 
                        in_conta: null, 
                        ch_digito_conta: null, 
                        st_observacoes: null, 
                    }, 
                };
                $('#contaModal').modal('show');
            });
        },

        load () { 
            this.$util.load(this, { 
                service: 'contas',
                with: [
                    'dados_bancarios',
                    'unidade_operacao',
                    'acessos', 
                ],
                parms: { 
                    cadastro: true, 
                }
            });
        },

    },

    mounted () { 
        this.load ();

        this.$util.loadItem(this, { 
            service: 'contas',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });

        if ( this.financeiro ) { 

            this.breadcrumb = [
                    { name: "Financeiro", path: "/financeiro/visao" },
                    { name: "Contas", path: "" },
                ];

        } else { 

            this.breadcrumb = [
                    { name: "Configurações", path: "/cadastros"},
                    { name: "Contas", path: "" },
                ];

        }

        this.$store.commit('setBreadcrumb', this.breadcrumb);
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>